import { render, staticRenderFns } from "./CreatorInvitationsPage.vue?vue&type=template&id=7a308f64"
import script from "./CreatorInvitationsPage.vue?vue&type=script&lang=ts"
export * from "./CreatorInvitationsPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports